<template>
  <div class="ListLojista">
    <HeaderPage>
      <el-button style="height: 44px; margin-left: 1rem" @click="$router.push({name:'config.lojista.create'})">Adicionar</el-button>
    </HeaderPage>
    
    <el-card v-loading="loadingPage">
      <FilterBoxLojista
        v-on:filter="listLogista"
        :currentPage="listData.meta ? listData.meta.pagination.current_page : 1"
      />

      
      <TableSimple :list-data="listData" @paginationClick="paginationClick">
        <el-table-column prop="id" label="#" width="80">
        </el-table-column>
        <el-table-column prop="name" label="Nome">
        </el-table-column>
        <el-table-column prop="marketplace.person.name_store" label="Marketplace">
        </el-table-column>

        <el-table-column width="100">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="Sincronizar grupo de lojistas" placement="top">
              <el-button type="text" @click="() => {syncGrupo(scope.row.id)}">
                <RefreshCwIcon size="1.2x" style="padding: 0 7px;"></RefreshCwIcon>
              </el-button>
            </el-tooltip>
            <el-button type="text" @click="() => {$router.push({name: 'config.lojista.edit', params: { id: scope.row.id }})}">
              <EditIcon size="1.2x" style="padding: 0 7px;"></EditIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import TableSimple from "@/app/components/Table/TableSimple";
import {getLogista, getMCC, postSyncLogista} from "@/app/domains/Config/services";
import {EditIcon, RefreshCwIcon} from "vue-feather-icons";
import dialogEditAddMcc from "@/app/domains/Config/components/mcc/dialogEditAddMcc";
import { XIcon } from "vue-feather-icons";
import {getErrorFilds, makeErrorFilds} from "@/app/plugins/utils";
import FilterBoxLojista from "@/app/domains/Config/components/Lojista/FilterBoxLojista";
export default {
  name: "ListLojista",
  components: {
    HeaderPage,
    TableSimple,
    EditIcon,
    RefreshCwIcon,
    FilterBoxLojista
  },
  data () {
    return {
      dialogEditAdd: false,
      loadingPage: true,
      idConta: '',
      listData: {},
      ruleForm: {
        searchInput: ''
      },
    }
  },
  methods: {
    syncGrupo (id) {
      this.$confirm('Deseja Sincronizar o grupo de lojistas?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        center: true,
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        try {
          await postSyncLogista(id)
          this.$message({
            showClose: true,
            message: 'Grupo de lojistas sincronizado',
            type: 'success'
          })
        } catch (e) {
          this.error = getErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {
        this.loadingPage = false
      });
    },
    init () {
      this.listLogista()
    },
    closeDialog() {
      this.idConta = ''
      this.dialogEditAdd = false
      this.init()
    },
    openDialog (id) {
      this.dialogEditAdd = true
      this.idConta = id
    },
    paginationClick (arg) {
      this.listLogista('?page='+arg.page)
    },
    async listLogista (query = '') {
      this.loadingPage = true
      try {
        let response = await getLogista(query)
        this.listData = response.data
      } catch (e) {
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    clearSearch () {
      this.$set(this.ruleForm, 'searchInput', '')
      this.init()
    },
    searchTable () {
      this.listLogista('?name='+this.ruleForm.searchInput)
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
